// AlertPopup.js
import React, { useEffect } from 'react';
// import './AlertPopup.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faExclamationTriangle,
  faTimesCircle,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';

function AlertPopup({
  title = "Alert",
  message = "",
  onClose,
  icon = null,
  type = "info", // success, error, warning, info
  isConfirmation = false,
  onConfirm,
  onCancel,
}) {
  useEffect(() => {
    if (!isConfirmation) {
      const timer = setTimeout(() => {
        onClose && onClose();
      }, 300000);
      return () => clearTimeout(timer);
    }
  }, [onClose, isConfirmation]);

  // Select icon based on type
  const getDefaultIcon = () => {
    switch (type) {
      case "success":
        return faCheckCircle;
      case "error":
        return faTimesCircle;
      case "warning":
        return faExclamationTriangle;
      case "info":
      default:
        return faInfoCircle;
    }
  };

  const renderIcon = () => {
    if (typeof icon === "string") {
      return <span className="alert-icon emoji">{icon}</span>; // fallback emoji
    }
    return (
      <FontAwesomeIcon
        icon={icon || getDefaultIcon()}
        className="alert-icon"
      />
    );
  };

  return (
    <div className="alert-popup ">
      <div className="alert-content iphone-popup">
        <div>{renderIcon()}</div>
        <div className='alert-text'>
        <h3 className="m-1">{title}</h3>
        <p className="m-0">{message}</p>
        </div>
        <div className="alert-foot d-flex">
          {isConfirmation ? (
            <>
              <button onClick={onConfirm} className="alert-close m-2">
                Confirm
              </button>
              <button onClick={onCancel} className="alert-close bg-white text-bg-light outline m-2">
                Cancel
              </button>
            </>
          ) : (
            <button onClick={onClose} className="alert-close m-2">
              OK
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default AlertPopup;
